import { render, staticRenderFns } from "./StudentLinking.vue?vue&type=template&id=4c1a2317&scoped=true&"
import script from "./StudentLinking.vue?vue&type=script&lang=js&"
export * from "./StudentLinking.vue?vue&type=script&lang=js&"
import style0 from "./StudentLinking.vue?vue&type=style&index=0&id=4c1a2317&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1a2317",
  null
  
)

export default component.exports